// extracted by mini-css-extract-plugin
export var editButton = "_ql-0";